import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_background_video = _resolveComponent("background-video")!
  const _component_widget_header = _resolveComponent("widget-header")!
  const _component_bot_avatar = _resolveComponent("bot-avatar")!
  const _component_select_chanel_refactor = _resolveComponent("select-chanel-refactor")!
  const _component_file_uploader = _resolveComponent("file-uploader")!
  const _component_answer_field = _resolveComponent("answer-field")!
  const _component_persistent_menu = _resolveComponent("persistent-menu")!
  const _component_dynamic_background = _resolveComponent("dynamic-background")!
  const _component_trigger_preview = _resolveComponent("trigger-preview")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", {
      class: "widget",
      style: _normalizeStyle({
			..._ctx.background,
			height: _ctx.windowHeightInPixels
		})
    }, [
      (_ctx.widget.bg_video_file)
        ? (_openBlock(), _createBlock(_component_background_video, {
            key: 0,
            src: _ctx.widget.bg_video_file
          }, null, 8, ["src"]))
        : _createCommentVNode("", true),
      (_ctx.isWidget)
        ? (_openBlock(), _createBlock(_component_widget_header, {
            key: 1,
            ref: "headerWidget",
            title: _ctx.bot.title,
            popupOpened: _ctx.popupOpened,
            usePrimaryColorAsBackground: !!_ctx.widget.bg_video_file,
            background: _ctx.background,
            isWidgetOpenedAtPhoneScreen: _ctx.isWidgetOpenedAtPhoneScreen,
            onTogglePopup: _ctx.togglePopup,
            onClosePopup: _ctx.closePopup
          }, null, 8, ["title", "popupOpened", "usePrimaryColorAsBackground", "background", "isWidgetOpenedAtPhoneScreen", "onTogglePopup", "onClosePopup"]))
        : _createCommentVNode("", true),
      (_ctx.isShowDynamicalAvatar)
        ? (_openBlock(), _createBlock(_component_bot_avatar, {
            key: 2,
            avatar: _ctx.bot.avatar,
            class: "bot-avatar",
            style: _normalizeStyle({ ..._ctx.avatarPosition })
          }, null, 8, ["avatar", "style"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        onScroll: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setAvatarPosition(false))),
        class: "messages-wrap"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "full-width row justify-center"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass({ centered: message.type !== 'carousel' })
            }, [
              (message.question_type === 'select_channel')
                ? (_openBlock(), _createBlock(_component_select_chanel_refactor, {
                    key: 0,
                    "display-type": "widget",
                    message: { ...message, order: index + 1 },
                    isShowMessageTail: _ctx.isShowBotAvatar(index),
                    isLastMessage: _ctx.isLastMessage(index),
                    is: _ctx.isComponentUse(message.type),
                    respondentId: _ctx.respondent.id,
                    isWidget: _ctx.isWidget,
                    avatar: _ctx.bot.avatar,
                    class: "q-mb-sm",
                    onSendMessage: _ctx.sendMessage,
                    onInit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollDown()))
                  }, null, 8, ["message", "isShowMessageTail", "isLastMessage", "is", "respondentId", "isWidget", "avatar", "onSendMessage"]))
                : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.isComponentUse(message.type)), {
                    key: 1,
                    message: { ...message, order: index + 1 },
                    isShowMessageTail: _ctx.isShowBotAvatar(index),
                    isLastMessage: _ctx.isLastMessage(index),
                    respondentId: _ctx.respondent.id,
                    isWidget: _ctx.isWidget,
                    avatar: _ctx.bot.avatar,
                    class: "q-mb-sm",
                    onSendMessage: _ctx.sendMessage,
                    onInit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollDown()))
                  }, null, 40, ["message", "isShowMessageTail", "isLastMessage", "respondentId", "isWidget", "avatar", "onSendMessage"])),
              (message.question_type === 'file')
                ? (_openBlock(), _createBlock(_component_file_uploader, {
                    key: 2,
                    class: "q-mb-sm",
                    message: message,
                    "project-id": _ctx.bot.project_id,
                    fingerprint: _ctx.fingerPrintService,
                    onSendMessage: _ctx.sendMessage
                  }, null, 8, ["message", "project-id", "fingerprint", "onSendMessage"]))
                : _createCommentVNode("", true)
            ], 2)
          ]))
        }), 128)),
        (!_ctx.isDialogModeInIframe)
          ? (_openBlock(), _createBlock(_component_answer_field, {
              key: 0,
              isShow: _ctx.isShowAnswerField,
              lastMessageQuestionType: _ctx.lastMessageQuestionType,
              class: "centered",
              onSendMessage: _ctx.sendMessage
            }, null, 8, ["isShow", "lastMessageQuestionType", "onSendMessage"]))
          : _createCommentVNode("", true),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "empty-block" }, null, -1))
      ], 32),
      _createVNode(_component_persistent_menu, {
        isShowAnswerField: _ctx.isDialogModeInIframe,
        persistentMenu: _ctx.persistentMenu,
        isShowBranding: _ctx.widget.branding ?? false,
        class: "persistent-menu",
        onSendMessage: _ctx.sendMessage
      }, null, 8, ["isShowAnswerField", "persistentMenu", "isShowBranding", "onSendMessage"]),
      (_ctx.isDynamicBackground)
        ? (_openBlock(), _createBlock(_component_dynamic_background, { key: 3 }))
        : _createCommentVNode("", true)
    ], 4), [
      [_vShow, _ctx.isWidgetOpen]
    ]),
    (_ctx.isShowTriggerPreview)
      ? (_openBlock(), _createBlock(_component_trigger_preview, {
          key: 0,
          respondentId: _ctx.respondent.id,
          class: "trigger-preview",
          widget: _ctx.widget,
          message: _ctx.botLastMessageWithoutTyping,
          isShowAnswerField: _ctx.isShowAnswerField,
          onSendMessage: _ctx.sendMessage
        }, null, 8, ["respondentId", "widget", "message", "isShowAnswerField", "onSendMessage"]))
      : _createCommentVNode("", true)
  ], 64))
}